<div class="my-quotes">
  <div class="topOfPage">
    <div class="header">
      <h1 tabindex="0">{{ state.sectionTop.heading }}</h1>
    </div>
  </div>
  <hr />
  <div class="middle-header">
    <h2 tabindex="0" class="sub-header">
      {{ state.sectionMiddle.heading }}
    </h2>
    
  </div>
  <div [ngClass]="{'middleOfPage' : utilService.bannerFlag, 'noPromoBanner': !utilService.bannerFlag}" >
    <tmhna-portal-equipment-quotes></tmhna-portal-equipment-quotes>
  </div>
  <div class="quote-promoBanners">
    <ng-container>
      <tmhna-portal-quote-promo-banners></tmhna-portal-quote-promo-banners>
    </ng-container>
  </div>
</div>
